import React from 'react';
import { Navigate } from 'react-router-dom';
import useCanPurchaseTracking from 'src/features/Purchase/useCanPurchaseTracking';
import PrivateRoute, { Props } from './PrivateRoute';

const PurchaseRoute: React.FC<Props> = ({ component }) => {
  const { canPurchaseTracking, isLoading } = useCanPurchaseTracking();

  if (isLoading) {
    return null;
  }

  if (!canPurchaseTracking) {
    return <Navigate to="/dashboard" replace />;
  }

  return <PrivateRoute component={component} />;
};

export default PurchaseRoute;
